import { render } from "./EditTargets.vue?vue&type=template&id=1b4cc5e3&scoped=true"
import script from "./EditTargets.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTargets.vue?vue&type=script&setup=true&lang=js"

import "./EditTargets.vue?vue&type=style&index=0&id=1b4cc5e3&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4cc5e3"],['__file',"resources/js/modules/product-mapping-tool/components/EditTargets.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b4cc5e3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b4cc5e3', __exports__)) {
    api.reload('1b4cc5e3', __exports__)
  }
  
  module.hot.accept("./EditTargets.vue?vue&type=template&id=1b4cc5e3&scoped=true", () => {
    api.rerender('1b4cc5e3', render)
  })

}


export default __exports__